export default __webpack_public_path__ + "static/media/rs_school_react.22d0519c.png";